import React, { useState, useEffect } from 'react'

import { useNavigate } from 'react-router-dom'

// Grommet
import { ResponsiveContext } from 'grommet'

import LocalStorageService from '../services/LocalStorageService'
import OrganisationTagService from '../services/OrganisationTagService'
import OrganisationService from '../services/OrganisationService'
import NotificationService from '../services/NotificationService'
import TermsService from '../services/TermsService'

// Appt Components
import Anchor from '../components/simple/anchor/Anchor'
import Box from '../components/simple/box/Box'
import CheckBox from '../components/simple/input/CheckBox'
import DataTable from '../components/simple/dataTable/DataTable.js'
import Divider from '../components/simple/divider/Divider'
import FontAwesome from '../components/compound/fontAwesome/FontAwesome'
import Form from '../components/simple/form/Form.js'
import FormField from '../components/simple/formField/FormField.js'
import Grid from '../components/simple/grid/Grid'
import Select from '../components/simple/input/Select'
import Text from '../components/simple/text/Text'
import TextInput from '../components/simple/input/TextInput'

import SelectDynamic from 'react-select';


// Shared Components
import BreadcrumbBar from './shared/BreadcrumbBar'

import constants from '../utils/constants'
import ActionButton from '../components/compound/actionButton/ActionButton.js'
import UserService from '../services/UserService.js'
import Button from '../components/simple/button/Button.js'

import { isAnyAdmin } from '../utils/permissions'
import PulseLoader from 'react-spinners/PulseLoader.js'

function ServiceSetup () {
  const navigate = useNavigate()

  const [behaviourLeads, setBehaviourLead] = useState([])
  const [safeguardingLeads, setSafeguardingLeads] = useState([])
  const [otherSystemAdmins, setOtherSystemAdmins] = useState([])
  const [originalOtherSystemAdmins, setOriginalOtherSystemAdmins] = useState([])
  const [otherSystemAdminsHasChanged, setOtherSystemAdminsHasChanged] = useState(false)
  const [behaviourLeadAddButton, setBehaviourLeadAddButton] = useState(false)

  const [deescalationTechniques, setDeescalationTechnique] = useState([])
  const [deescalationAddButton, setDeescalationAddButton] = useState(false)

  const [physicalTechniques, setPhysicalTechnique] = useState([])
  const [physicalAddButton, setPhysicalAddButton] = useState(false)

  const [quickBehaviours, setQuickBehaviours] = useState([])
  const [quickBehaviourAddButton, setQuickBehaviourAddButton] = useState(false)

  // Has the Service got terms ?
  const [serviceHasTerms, setServiceHasTerms] = useState(false)
  const [wondeIntegration, setWondeIntegration] = useState(false)

  const [cpomsEnabled, setCpomsEnabled] = useState(false)
  const [cpomsSyncEverything, setCpomsSyncEverything] = useState(false)
  const [cpomsDomain, setCpomsDomain] = useState(null)

  const [enablePILExtras, setEnablePILExtras] = useState(false);
  const [aiTermsAccepted, setAiTermsAccepted] = useState(false);

  const [allStaff, setAllStaff] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [isAuthorised, setIsAuthorised] = useState(false);

  // What gets rendered
  const [deescalationTechniquesDisplay, setDeescalationTechniquesDisplay] = useState()

  const allAcademicYearStartDays = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31']
  const allAcademicYearStartMonths = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

  const allAcademicYears = constants.academicYears
  const apiToken = LocalStorageService.get('apiToken')
  const activeOrg = LocalStorageService.get('activeOrg')

  // Initialize userDetails otherwise we get error
  // A component is changing an uncontrolled input of type text to be controlled
  const [serviceDetails, setServiceDetails] = useState({
    serviceUserTerm: '',
    serviceUserTermPlural: '',
    serviceTerm: '',
    serviceTermPlural: '',
    academicYearStartDay: '',
    academicYearStartMonth: '',
    enabledAcademicYears: '',
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    safeguardingFirstName: '',
    safeguardingLastName: '',
    safeguardingPhone: '',
    safeguardingEmail: '',
    deescalationTechnique: '',
    physicalTechnique: ''
  })

  // Remove a technique from the list
  const removeTechnique = (type, index) => {
    if (type === 'deescalation') {
      const newDeescalationTechniques = deescalationTechniques.slice(0, index).concat(deescalationTechniques.slice(index + 1, deescalationTechniques.length))
      // const newDeescalationTechniques = deescalationTechniques
      // newDeescalationTechniques.splice(index, 1)
      setDeescalationTechnique(newDeescalationTechniques)
    } else {
      const newPhysicalTechniques = physicalTechniques.slice(0, index).concat(physicalTechniques.slice(index + 1, physicalTechniques.length))
      setPhysicalTechnique(newPhysicalTechniques)
    }
  }

  // Submit form values
  // ToDo: Add error checking and loading spinner
  const submitForm = async (values) => {
    const tagsToSubmit = []

    // Set up tags for Service Defaults
    const serviceDefaultsToSubmit = ['serviceUserTerm', 'serviceUserTermPlural', 'serviceTerm', 'serviceTermPlural', 'academicYearStartDay', 'academicYearStartMonth', 'enabledAcademicYears']

    let termValue

    // If field being saved is a term tag AND service has no terms
    // then set to null to clear value
    const termTags = ['academicYearStartDay', 'academicYearStartMonth', 'enabledAcademicYears']

    serviceDefaultsToSubmit.forEach(field => {
      if (!serviceHasTerms && termTags.includes(field)) {
        termValue = null
      } else {
        if (field === 'enabledAcademicYears') {
          termValue = JSON.stringify(values[field])
        } else {
          termValue = values[field]
        }
      }

      tagsToSubmit.push({
        organisation: activeOrg.id,
        key: field,
        type: 'besmart',
        // value: field === 'enabledAcademicYears' ? JSON.stringify(values[field]) : values[field]
        value: termValue
      })
    })

    // And Behaviour Leads if there are any
    if (behaviourLeads.length > 0) {
      var leads = []

      behaviourLeads.forEach(lead => {
        leads.push(lead)
      })

      tagsToSubmit.push({
        organisation: activeOrg.id,
        key: 'behaviourLeads',
        type: 'besmart',
        value: JSON.stringify(leads)
      })
    }

    // And Safeguarding Leads if there are any
    if (safeguardingLeads.length > 0) {
      var sleads = []

      safeguardingLeads.forEach(lead => {
        sleads.push(lead)
      })

      tagsToSubmit.push({
        organisation: activeOrg.id,
        key: 'safeguardingLeads',
        type: 'besmart',
        value: JSON.stringify(sleads)
      })
    }

    // And Deescalation Techniques if there are any
    if (deescalationTechniques.length > 0) {
      const techniques = []

      deescalationTechniques.forEach(technique => {
        techniques.push(technique)
      })

      tagsToSubmit.push({
        organisation: activeOrg.id,
        key: 'deescalationTechniques',
        type: 'besmart',
        value: JSON.stringify(techniques)
      })
    }

    // And Physical Techniques if there are any
    if (physicalTechniques.length > 0) {
      const techniques = []

      physicalTechniques.forEach(technique => {
        techniques.push(technique)
      })

      tagsToSubmit.push({
        organisation: activeOrg.id,
        key: 'physicalTechniques',
        type: 'besmart',
        value: JSON.stringify(techniques)
      })
    }

    // And Physical Techniques if there are any
    if (quickBehaviours.length > 0) {
      const newQuickBehaviours = []

      quickBehaviours.forEach(technique => {
        newQuickBehaviours.push(technique)
      })

      tagsToSubmit.push({
        organisation: activeOrg.id,
        key: 'quickBehaviours',
        type: 'besmart',
        value: JSON.stringify(newQuickBehaviours)
      })
    }

    const params = {
      orgId: activeOrg.id
    }

    await OrganisationTagService.set(apiToken, params, tagsToSubmit)

    activeOrg.wondeSync = wondeIntegration
    activeOrg.enablePILExtras = enablePILExtras;
    activeOrg.aiTermsAccepted = aiTermsAccepted;
    LocalStorageService.set('activeOrg', activeOrg)
    await OrganisationService.updateOrganisation(apiToken, {
      id: activeOrg.id,
      wondeSync: wondeIntegration,
      enablePILExtras: enablePILExtras,
      aiTermsAccepted: aiTermsAccepted,
      cpomsEnabled: cpomsEnabled,
      cpomsSyncEverything: cpomsSyncEverything
    });

    // update the other admins for the organisation, if changed
    if (otherSystemAdminsHasChanged) {

      // get the admins that have been removed
      const removedAdmins = originalOtherSystemAdmins.filter(originalAdmin => !otherSystemAdmins.some(admin => admin.id === originalAdmin.id));
      for (const admin of removedAdmins) {
        await OrganisationService.removeOtherAdmin(apiToken, activeOrg.id, admin.id);
      }

      const newAdmins = otherSystemAdmins.filter(admin => !originalOtherSystemAdmins.some(originalAdmin => originalAdmin.id === admin.id));
      for (const admin of newAdmins) {
        await OrganisationService.addOtherAdmin(apiToken, activeOrg.id, admin.id);
      }
    }

    // refresh and set the terms
    const matchedTerms = await TermsService.getCommonTerms()
    LocalStorageService.set('terms', matchedTerms)

    NotificationService.success('Your changes have been saved')
    // force the screen to refresh to ensure the service terms update

    // set a timeout to display a success message
    setTimeout(() => { window.location.reload() }, 1500)
    // window.location.reload()
  }

  const addBehaviourLead = () => {
    // Don't save if all fields empty
    if (serviceDetails.firstName !== '' || serviceDetails.lastName !== '' || serviceDetails.phone !== '' || serviceDetails.email !== '') {
      const lead = {
        firstName: serviceDetails.firstName,
        lastName: serviceDetails.lastName,
        phone: serviceDetails.phone,
        email: serviceDetails.email
      }
      setBehaviourLead(behaviourLeads => [...behaviourLeads, lead])

      setServiceDetails(serviceDetails => ({
        ...serviceDetails,
        firstName: '',
        lastName: '',
        phone: '',
        email: ''
      }))
      // setBehaviourLeadAddButton(false)
    }
  }

  const removeBehaviourLead = (data) => {
    const newLeads = behaviourLeads.filter((item) => item.email !== data.email)

    setBehaviourLead(newLeads)
  }

  const editBehaviourLead = (data) => {
    setServiceDetails(serviceDetails => ({
      ...serviceDetails,
      firstName: data.firstName,
      lastName: data.lastName,
      phone: data.phone,
      email: data.email
    }))

    removeBehaviourLead(data)
  }

  const addSafeguardingLead = () => {
    // Don't save if all fields empty
    if (serviceDetails.safeguardingFirstName !== '' || serviceDetails.safeguardingLastName !== '' || serviceDetails.safeguardingPhone !== '' || serviceDetails.safeguardingmail !== '') {
      const lead = {
        firstName: serviceDetails.safeguardingFirstName,
        lastName: serviceDetails.safeguardingLastName,
        phone: serviceDetails.safeguardingPhone,
        email: serviceDetails.safeguardingEmail.toLocaleLowerCase()
      }
      setSafeguardingLeads(safeguardingLeads => [...safeguardingLeads, lead])

      setServiceDetails(serviceDetails => ({
        ...serviceDetails,
        safeguardingFirstName: '',
        safeguardingLastName: '',
        safeguardingPhone: '',
        safeguardingEmail: ''
      }))
      // setSafeguardingLeadAddButton(false)
    }
  }

  const removeSafeguardingLead = (data) => {
    const newLeads = safeguardingLeads.filter((item) => item.email !== data.email)

    setSafeguardingLeads(newLeads)
  }

  const editSafeguardingLead = (data) => {
    setServiceDetails(serviceDetails => ({
      ...serviceDetails,
      safeguardingFirstName: data.firstName,
      safeguardingLastName: data.lastName,
      safeguardingPhone: data.phone,
      safeguardingEmail: data.email.toLocaleLowerCase()
    }))

    removeSafeguardingLead(data)
  }

  const deescalationTechniqueSelect = (technique) => {
    setDeescalationTechnique(
      deescalationTechniques.map(item =>
        item.technique === technique
          ? { ...item, selected: !item.selected }
          : item
      ))
  }

  const addDeescalationTechnique = () => {
    const techniqueExists = deescalationTechniques.find((item, index) => {
      return (item.technique === serviceDetails.deescalationTechnique)
    })

    if (techniqueExists) {
      NotificationService.error('Deescalation technique already exists, please add a different one')
    } else {
      // Add technique and set to selected
      const technique = {
        technique: serviceDetails.deescalationTechnique,
        selected: true
      }
      setDeescalationTechnique(deescalationTechniques => [...deescalationTechniques, technique])

      // Clear input
      setServiceDetails(serviceDetails => ({
        ...serviceDetails,
        deescalationTechnique: ''
      }))

      // Disable Add button
      setDeescalationAddButton(false)
    }
  }

  const physicalTechniqueSelect = (technique) => {
    setPhysicalTechnique(
      physicalTechniques.map(item =>
        item.technique === technique
          ? { ...item, selected: !item.selected }
          : item
      ))
  }

  const addPhysicalTechnique = () => {
    const techniqueExists = physicalTechniques.find((item, index) => {
      return (item.technique === serviceDetails.physicalTechnique)
    })

    if (techniqueExists) {
      NotificationService.error('Physical technique already exists, please add a different one')
    } else {
      // Add technique and set to selected
      const technique = {
        technique: serviceDetails.physicalTechnique,
        selected: true
      }
      setPhysicalTechnique(physicalTechniques => [...physicalTechniques, technique])

      // Clear input
      setServiceDetails(serviceDetails => ({
        ...serviceDetails,
        physicalTechnique: ''
      }))

      // Disable Add button
      setPhysicalAddButton(false)
    }
  }


  const quickBehaviourSelect = (quickBehaviour) => {
    setQuickBehaviours(
      quickBehaviours.map(item =>
        item.quickBehaviour === quickBehaviour
          ? { ...item, selected: !item.selected }
          : item
      ))
  }

  const removeQuickBehaviour = (index) => {
    const newQuickBehaviours = quickBehaviours.slice(0, index).concat(quickBehaviours.slice(index + 1, quickBehaviours.length))
    setQuickBehaviours(newQuickBehaviours)
  }

  const addQuickBehaviour = () => {


    const exists = quickBehaviours.find((item, index) => {
      return (item.quickBehaviour === serviceDetails.quickBehaviour)
    })

    if (exists) {
      NotificationService.error('Quick behaviour already exists, please add a different one')
    } else {
      // Add behaviour and set to selected
      const behaviour = {
        quickBehaviour: serviceDetails.quickBehaviour,
        selected: true
      }

      setQuickBehaviours(quickBehaviours => [...quickBehaviours, behaviour])

      // Clear input
      setServiceDetails(serviceDetails => ({
        ...serviceDetails,
        quickBehaviour: ''
      }))

      // Disable Add button
      setQuickBehaviourAddButton(false)
    }
  }

  const goBack = () => {
    navigate(-1)
  }

  // always get the latest settings
  useEffect(() => {
    const refreshOrgData = async () => {
      if (activeOrg?.id) {
        const response = await OrganisationService.getOrganisation(apiToken, activeOrg.id);
        if (response?.data?.length) {
          setWondeIntegration(!!response.data[0]?.wondeSync)
          setEnablePILExtras(!!response.data[0]?.enablePILExtras);
          setAiTermsAccepted(!!response.data[0]?.aiTermsAccepted);

          setCpomsDomain(response.data[0]?.cpomsDomain || null);
          setCpomsEnabled(!!response.data[0]?.cpomsEnabled)
          setCpomsSyncEverything(!!response.data[0]?.cpomsSyncEverything)
        }
      }
    }
    refreshOrgData()

  }, [activeOrg.id])

  useEffect(() => {
    let unmounted = false

    const getServiceSetup = async () => {
      const params = {
        fields: 'type,key,value',
        limit: 100,
        orgId: activeOrg.id
      }

      const where = {
        type: 'besmart'
      }

      const organisationTags = await OrganisationTagService.get(apiToken, params, where)

      // ToDo: Add error checking and loading spinner
      if (!unmounted) {
        const tags = {}
        let bLeads = []
        let sLeads = []
        let deescalationTechniques = [
          {
            technique: 'Empathy',
            selected: true
          },
          {
            technique: 'Verbal advice and support',
            selected: true
          },
          {
            technique: 'Giving Space',
            selected: true
          },
          {
            technique: 'Reassurance',
            selected: true
          },
          {
            technique: 'Scripts',
            selected: true
          },
          {
            technique: 'Negotiation',
            selected: true
          },
          {
            technique: 'Positive Choices',
            selected: true
          },
          {
            technique: 'Humour',
            selected: true
          },
          {
            technique: 'Logical Consequences',
            selected: true
          },
          {
            technique: 'Tactical Ignoring',
            selected: true
          },
          {
            technique: 'Take up time',
            selected: true
          },
          {
            technique: 'Time-out',
            selected: true
          },
          {
            technique: 'Supportive touch',
            selected: true
          },
          {
            technique: 'Transfer staff',
            selected: true
          },
        ]
        let physicalTechniques = []
        let newQuickBehaviours = []

        if (organisationTags) {
          organisationTags.forEach(tag => {
            switch (tag.key) {
              case 'serviceUserTerm':
                tags.serviceUserTerm = tag.value
                break
              case 'serviceUserTermPlural':
                tags.serviceUserTermPlural = tag.value
                break
              case 'serviceTerm':
                tags.serviceTerm = tag.value
                break
              case 'serviceTermPlural':
                tags.serviceTermPlural = tag.value
                break
              case 'academicYearStartDay':
                tags.academicYearStartDay = tag.value
                break
              case 'academicYearStartMonth':
                tags.academicYearStartMonth = tag.value
                break
              case 'enabledAcademicYears':
                try {
                  tags.enabledAcademicYears = JSON.parse(tag.value)
                } catch (err) {
                  console.error(err)
                }
                break
              case 'behaviourLeads':
                try {
                  bLeads = JSON.parse(tag.value)
                } catch (err) {
                  console.error(err)
                }
                break
              case 'safeguardingLeads':
                try {
                  sLeads = JSON.parse(tag.value)
                } catch (err) {
                  console.error(err)
                }
                break
              case 'deescalationTechniques':
                try {
                  deescalationTechniques = JSON.parse(tag.value)
                } catch (err) {
                  console.error(err)
                }
                break
              case 'physicalTechniques':
                try {
                  physicalTechniques = JSON.parse(tag.value)
                } catch (err) {
                  console.error(err)
                }
                break

              case 'quickBehaviours':
                try {
                  newQuickBehaviours = JSON.parse(tag.value)
                } catch (err) {
                  console.error(err)
                }
                break
            }
          })
        }

        setServiceDetails(serviceDetails => ({
          ...serviceDetails,
          serviceUserTerm: tags.serviceUserTerm,
          serviceUserTermPlural: tags.serviceUserTermPlural,
          serviceTerm: tags.serviceTerm,
          serviceTermPlural: tags.serviceTermPlural,
          academicYearStartDay: tags.academicYearStartDay,
          academicYearStartMonth: tags.academicYearStartMonth,
          enabledAcademicYears: tags.enabledAcademicYears
        }))
        setServiceHasTerms(tags.academicYearStartDay || false)
        setBehaviourLead(bLeads)
        setSafeguardingLeads(sLeads)
        setDeescalationTechnique(deescalationTechniques)
        setPhysicalTechnique(physicalTechniques)
        setQuickBehaviours(newQuickBehaviours)
      }
    }

    setIsLoading(true);
    getServiceSetup().then(() => {
       isAnyAdmin().then(result => {
        setIsAuthorised(result);
        setIsLoading(false);
      });
    });

    return () => { unmounted = true }
  }, [])

  const fetchOtherAdmins = async () => {
    const otherAdmins = await OrganisationService.getOtherAdmins(apiToken, activeOrg.id);
    const data = otherAdmins?.data || [];
    setOtherSystemAdmins(data);
    setOriginalOtherSystemAdmins(data);
  };
  useEffect(() => {
    fetchOtherAdmins();
  }, []);



   const getStaff = async () => {

    const params = {
      fields: 'id,firstName,lastName,email,reference,type',
      limit: 1000,
      orgId: activeOrg.id,
      type: 'user'
    };
    const users = await UserService.getUsers(apiToken, params);
    return users;
  };

  useEffect(() => {
    const fetchStaff = async () => {
      const users = await getStaff();
      setAllStaff(users?.data || []);
    };
    fetchStaff();
  }, []);

  // Behaviour Leads have been altered
  // so rebuild the display list
  const [mappedBehaviourLeads, setMappedBehaviourLeads] = useState([])
  const [behaviourLeadColumns, setBehaviourLeadDataColumns] = useState()

  useEffect(() => {
    setBehaviourLeadDataColumns([
      {
        property: 'firstName',
        header: <Text pad='none' margin='none'>First Name</Text>
      },
      {
        property: 'lastName',
        header: <Text>Last Name</Text>
      },
      {
        property: 'phone',
        header: <Text>Phone</Text>
      },
      {
        property: 'email',
        header: <Text>Email</Text>
      },
      {
        property: 'actions',
        render: datum => (
          <Box direction='row'>
            <ActionButton label={<Text><FontAwesome icon={['fal', 'minus-circle']} /></Text>} margin={{ horizontal: 'xsmall' }} style={{ background: 'besmartOrange' }} onClick={() => removeBehaviourLead(datum)} target='_self' />
            <ActionButton label={<Text><FontAwesome icon={['fal', 'edit']} /></Text>} margin={{ horizontal: 'xsmall' }} style={{ background: 'besmartOrange' }} onClick={() => editBehaviourLead(datum)} target='_self' />
          </Box>
        )
      }
    ])

    const mappedBehaviourLeads = behaviourLeads.map((lead, index) => ({
      firstName: lead.firstName,
      lastName: lead.lastName,
      phone: lead.phone,
      email: lead.email
    }))

    setMappedBehaviourLeads(mappedBehaviourLeads)
  }, [behaviourLeads])

  // Safeguarding Leads have been altered
  // so rebuild the display list
  const [mappedSafeguardingLeads, setMappedSafeguardingLeads] = useState([])
  const [safeguardingLeadColumns, setSafeguardingLeadDataColumns] = useState()

  useEffect(() => {
    setSafeguardingLeadDataColumns([
      {
        property: 'firstName',
        header: <Text pad='none' margin='none'>First Name</Text>
      },
      {
        property: 'lastName',
        header: <Text>Last Name</Text>
      },
      {
        property: 'phone',
        header: <Text>Phone</Text>
      },
      {
        property: 'email',
        header: <Text>Email</Text>
      },
      {
        property: 'actions',
        render: datum => (
          <Box direction='row'>
            <ActionButton label={<Text><FontAwesome icon={['fal', 'minus-circle']} /></Text>} margin={{ horizontal: 'xsmall' }} style={{ background: 'besmartOrange' }} onClick={() => removeSafeguardingLead(datum)} target='_self' />
            <ActionButton label={<Text><FontAwesome icon={['fal', 'edit']} /></Text>} margin={{ horizontal: 'xsmall' }} style={{ background: 'besmartOrange' }} onClick={() => editSafeguardingLead(datum)} target='_self' />
          </Box>
        )
      }
    ])

    const mappedSafeguardingLeads = safeguardingLeads.map((lead, index) => ({
      firstName: lead.firstName,
      lastName: lead.lastName,
      phone: lead.phone,
      email: lead.email
    }))

    setMappedSafeguardingLeads(mappedSafeguardingLeads)
  }, [safeguardingLeads])

  return (
    <Box>
      <BreadcrumbBar
        title="Service Setup"
        path={
          <>
            <Anchor href="/">BehaviourSmart</Anchor>
            <Text color="besmartBlue" size="xsmall">
              {window.location.pathname}
            </Text>
          </>
        }
      />
      {isLoading && <Box width='xlarge' gap='medium' margin={{ bottom: 'medium' }} pad={{ vertical: 'medium' }} align='center' justify='center' background='white' round='small'>
        <Text size='large' weight='bold' color='dark-3'>Loading...</Text>
        <PulseLoader
          size={15}
          color='#ff8300'
        />
      </Box>}

      {!isLoading && !isAuthorised && <Box width='xlarge' gap='small' margin={{ bottom: 'medium' }} pad={{ vertical: 'medium' }} align='center' justify='center' background='white' round='small'>
        <Text size='large' weight='bold' color='secondary'>You are not authorised to view this page</Text>
        <Text size='medium' color='secondary'>Please contact your system administrator if you believe this is an error</Text>
      </Box>}

      {!isLoading && isAuthorised && <>
        <Box
          background="white"
          direction="column"
          gap="small"
          round="small"
          flex="grow"
          margin={{ bottom: 'medium' }}
        >
          <Box
            gap="small"
            margin={{ horizontal: 'small' }}
            pad="small"
            round="small"
          >
            <Text margin={{ top: 'xsmall' }} size="large">
              Wonde Integration
            </Text>
            <CheckBox
              checked={wondeIntegration}
              label={<Text>Enable MIS Integration</Text>}
              onChange={() => setWondeIntegration(!wondeIntegration)}
            />
          </Box>
        </Box>

        {cpomsDomain && <Box background='white' direction='column' gap='small' round='small' flex='grow' margin={{ bottom: 'medium' }}>
          <Box
            gap='small'
            margin={{ horizontal: 'small' }}
            pad={{
              top: 'small',
              horizontal: 'small',
              bottom: 'medium'
            }}
            round='small'
          >
            <Text margin={{ top: 'xsmall' }} size='large'>CPOMS Integration</Text>
            <CheckBox checked={cpomsEnabled} label={<Text>Enable CPOMS Integration</Text>} onChange={() => setCpomsEnabled(!cpomsEnabled)} />
            {cpomsEnabled && <CheckBox checked={cpomsSyncEverything} label={<Text>Sync all incidents with CPOMS (leave unchecked to require incidents to be manually selected)</Text>} onChange={() => setCpomsSyncEverything(!cpomsSyncEverything)} />}

          </Box>
        </Box>}

        {!serviceDetails?.serviceTerm && (
          <Box
            background="white"
            direction="column"
            gap="small"
            round="small"
            flex="grow"
            margin={{ bottom: 'medium' }}
          >
            <Box
              gap="small"
              margin={{ horizontal: 'small' }}
              pad="small"
              round="small"
            >
              <Text margin={{ top: 'xsmall' }} size="large">
                Setup to Continue
              </Text>
              <Text margin={{ bottom: 'xsmall' }}>
                Please complete the following information before using
                BehaviourSmart.
              </Text>
            </Box>
          </Box>
        )}

        <Box
          background="white"
          direction="column"
          gap="small"
          round="small"
          flex="grow"
        >
          <Box
            gap="small"
            margin={{ horizontal: 'small' }}
            pad="small"
            round="small"
          >
            <Box direction="column" gap="medium">
              <Form
                onChange={nextValue => {
                  // Enable Behaviour Lead Add button if all fields have data
                  // setBehaviourLeadAddButton(nextValue.firstName !== '' && nextValue.lastName !== '' && nextValue.phone !== '' && nextValue.email !== '')

                  // Enable Quick Behaviour Add button if field has data
                  setQuickBehaviourAddButton(nextValue.quickBehaviour);

                  // Enable Deescalation Technique Add button if field has data
                  setDeescalationAddButton(nextValue.deescalationTechnique);
                  // Enable Physical Technique Add button if field has data
                  setPhysicalAddButton(nextValue.physicalTechnique);
                  setServiceDetails(nextValue);
                }}
                onSubmit={({ value: nextValue }) => {
                  submitForm(nextValue);
                }}
                value={serviceDetails}
              >
                <Box fill direction="row" gap="small">
                  <Text margin={{ top: 'xsmall' }} size="large">
                    What type of service are you? Eg. School, Children’s Home,
                    Health Care Setting.
                  </Text>
                  <Button
                    label={
                      <FontAwesome
                        color="brand"
                        icon={['fas', 'question-circle']}
                      />
                    }
                    plain
                    tip={{
                      content: (
                        <Box
                          background={{ color: 'white' }}
                          border={{ color: 'brand', size: 'small' }}
                          direction="column"
                          pad="small"
                        >
                          <Text>
                            What type of service are you? Eg. School, Children’s
                            Home, Health Care Setting.
                          </Text>
                        </Box>
                      ),
                    }}
                  />
                </Box>

                <Box direction="row-responsive" gap="medium">
                  <FormField
                    label="Service (singular)"
                    name="serviceTerm"
                    required
                  >
                    <TextInput
                      name="serviceTerm"
                      placeholder="service"
                      type="text"
                    />
                  </FormField>

                  <FormField
                    label="Service (plural)"
                    name="serviceTermPlural"
                    required
                  >
                    <TextInput
                      name="serviceTermPlural"
                      placeholder="services"
                      type="text"
                    />
                  </FormField>
                </Box>

                <Divider color="primary" margin={{ vertical: 'small' }} />

                <Box fill direction="row" gap="small">
                  <Text margin={{ top: 'xsmall' }} size="large">
                    How do you refer to the individuals who use your service? Eg.
                    Students, Pupils, Young People, Clients.
                  </Text>
                  <Button
                    label={
                      <FontAwesome
                        color="brand"
                        icon={['fas', 'question-circle']}
                      />
                    }
                    plain
                    tip={{
                      content: (
                        <Box
                          background={{ color: 'white' }}
                          border={{ color: 'brand', size: 'small' }}
                          direction="column"
                          pad="small"
                        >
                          <Text>
                            How do you refer to the individuals who use your
                            service? Eg. Students, Pupils, Young People, Clients.
                          </Text>
                        </Box>
                      ),
                    }}
                  />
                </Box>

                <Box direction="column">
                  <Box direction="row-responsive" gap="medium">
                    <FormField
                      label="Service User (singular)"
                      name="serviceUserTerm"
                      required
                    >
                      <TextInput
                        name="serviceUserTerm"
                        placeholder="service user"
                        type="text"
                      />
                    </FormField>

                    <FormField
                      label="Service Users (plural)"
                      name="serviceUserTermPlural"
                      required
                    >
                      <TextInput
                        name="serviceUserTermPlural"
                        placeholder="service users"
                        type="text"
                      />
                    </FormField>
                  </Box>

                  <Divider color="primary" margin={{ vertical: 'small' }} />
                  <Text margin={{ top: 'xsmall' }} size="large">
                    Term dates and year groups covered
                  </Text>

                  <CheckBox
                    checked={serviceHasTerms}
                    label={<Text>My service has term dates</Text>}
                    onChange={() => setServiceHasTerms(!serviceHasTerms)}
                  />

                  {serviceHasTerms && (
                    <>
                      <Box direction="row-responsive" gap="medium">
                        <FormField
                          label="Start Day"
                          name="academicYearStartDay"
                          required
                        >
                          <Select
                            name="academicYearStartDay"
                            options={allAcademicYearStartDays}
                          />
                        </FormField>

                        <FormField
                          label="Start Month"
                          name="academicYearStartMonth"
                          required
                        >
                          <Select
                            name="academicYearStartMonth"
                            options={allAcademicYearStartMonths}
                          />
                        </FormField>

                        <FormField
                          label="Years Covered"
                          name="enabledAcademicYears"
                          required
                        >
                          <Select
                            closeOnChange={false}
                            multiple
                            name="enabledAcademicYears"
                            options={allAcademicYears}
                          />
                        </FormField>
                      </Box>
                    </>
                  )}
                </Box>

                <Divider color="primary" margin={{ vertical: 'small' }} />

                <Box fill direction="row" gap="small" margin={{ bottom: 'none' }}>
                  <Text margin={{ top: 'xsmall', bottom: 'none' }} size="large">
                    Who would you like to receive a copy of the Incident Reports,
                    Logs and Plans when they have been completed?
                  </Text>
                  <Button
                    label={
                      <FontAwesome
                        color="brand"
                        icon={['fas', 'question-circle']}
                      />
                    }
                    plain
                    tip={{
                      content: (
                        <Box
                          background={{ color: 'white' }}
                          border={{ color: 'brand', size: 'small' }}
                          direction="column"
                          pad="small"
                        >
                          <Text>
                            Users below will have the ability to view ALL incident Reports and get access to Behaviour Smart Analytics and System Users page.
                          </Text>
                        </Box>
                      ),
                    }}
                  />
                </Box>

                <Box direction="row-responsive" gap="medium">
                  <ResponsiveContext.Consumer>
                    {responsive => (
                      <DataTable
                        columns={
                          ['xsmall', 'small'].includes(responsive)
                            ? behaviourLeadColumns?.filter(
                                el =>
                                  el.property !== 'phone' &&
                                  el.property !== 'email',
                              )
                            : behaviourLeadColumns
                        }
                        data={mappedBehaviourLeads}
                        fill="horizontal"
                        size="large"
                      />
                    )}
                  </ResponsiveContext.Consumer>
                </Box>
                <Box direction="row-responsive" gap="medium">
                  <FormField label="First Name" name="firstName">
                    <TextInput name="firstName" type="text" />
                  </FormField>

                  <FormField label="Last Name" name="lastName">
                    <TextInput name="lastName" type="text" />
                  </FormField>

                  <FormField label="Phone Number" name="phone">
                    <TextInput name="phone" type="text" />
                  </FormField>

                  <FormField label="Email" name="email">
                    <TextInput name="email" type="email" />
                  </FormField>

                  {/* <ActionButton disabled={!behaviourLeadAddButton} label={<Text><FontAwesomeIcon icon={['fal', 'plus-circle']} /></Text>} color='primary' onClick={() => addLead()} style={{ height: '35px' }} alignSelf='end' margin={{ bottom: 'small' }} /> */}
                  <ActionButton
                    label={<Text>Add</Text>}
                    color="primary"
                    onClick={() => addBehaviourLead()}
                    style={{ height: '35px' }}
                    alignSelf="end"
                    margin={{ bottom: 'small' }}
                  />
                </Box>

                <Divider color="primary" margin={{ vertical: 'small' }} />

                <Box fill direction="row" gap="small" margin={{ bottom: 'none' }}>
                  <Text margin={{ top: 'xsmall' }} size="large">
                    Permissions
                  </Text>
                  <Button
                    label={
                      <FontAwesome
                        color="brand"
                        icon={['fas', 'question-circle']}
                      />
                    }
                    plain
                    tip={{
                      content: (
                        <Box
                          background={{ color: 'white' }}
                          border={{ color: 'brand', size: 'small' }}
                          direction="column"
                          pad="small"
                        >
                          <Text>
                            Define who should have access to the privileged sections of the system. Only the user specified below will have access.
                          </Text>
                        </Box>
                      ),
                    }}
                  />
                </Box>
                <Box
                  fill
                  direction="column"
                  gap="small"
                  margin={{ top: 'none', bottom: 'small' }}
                >
                  <Text margin={{ top: 'small' }} size="medium">
                    Analytics, System Users, and all Incidents 
                  </Text>
                  <Text size="small">
                    Who would you like to have access to the Analytics, System Users, and all Incidents?
                  </Text>
                  <Box direction="row" gap="medium" width="100%">

                    <SelectDynamic
                      isMulti
                      isClearable={false}
                      isLoading={isLoading}
                      width="100%"
                      onChange={(selectedOptions) => {
                        setSafeguardingLeads(selectedOptions)
                      }}
                      options={allStaff?.filter(staff => !safeguardingLeads.map(lead => lead.email).includes(staff.email)).map(staff => ({
                        label: `${staff.firstName} ${staff.lastName}`,
                        value: staff.id,
                        firstName: staff.firstName,
                        lastName: staff.lastName,
                        email: staff.email
                      }))}
                      value={safeguardingLeads.map(lead => ({
                        label: `${lead.firstName} ${lead.lastName}`,
                        value: lead.email,
                        firstName: lead.firstName,
                        lastName: lead.lastName,
                        email: lead.email
                      }))}
                      ma
                    />
                  </Box>
                </Box>

                <Box
                  fill
                  direction="column"
                  gap="small"
                  margin={{ top: 'none', bottom: 'small' }}
                >
                  <Text margin={{ top: 'small' }} size="medium">
                    Service Setup
                  </Text>
                  <Text size="small">
                    Who would you like to have access to the Service Setup (this page)? The organisation admin will always have access to this page, even if they're not listed below.
                  </Text>
                  <Box direction="row" gap="medium" width="100%">

                    <SelectDynamic
                      isMulti
                      isClearable={false}
                      isLoading={isLoading}
                      width="100%"
                      onChange={(selectedOptions) => {
                        setOtherSystemAdmins(selectedOptions)
                        setOtherSystemAdminsHasChanged(true)
                      }}
                      options={allStaff?.filter(staff => !otherSystemAdmins.map(admin => admin.email).includes(staff.email)).map(staff => ({
                        label: `${staff.firstName} ${staff.lastName}`,
                        value: staff.email,
                        id: staff.id,
                        firstName: staff.firstName,
                        lastName: staff.lastName,
                        email: staff.email
                      }))}
                      value={otherSystemAdmins.map(admin => ({
                        label: `${admin.firstName} ${admin.lastName}`,
                        value: admin.email,
                        id: admin.id,
                        firstName: admin.firstName,
                        lastName: admin.lastName,
                        email: admin.email
                      }))}
                      ma
                    />
                  </Box>
                </Box>

              
                {/* <Box direction="row-responsive" gap="medium">
                  <FormField label="First Name" name="safeguardingFirstName">
                    <TextInput name="safeguardingFirstName" type="text" />
                  </FormField>

                  <FormField label="Last Name" name="safeguardingLastName">
                    <TextInput name="safeguardingLastName" type="text" />
                  </FormField>

                  <FormField label="Phone Number" name="safeguardingPhone">
                    <TextInput name="safeguardingPhone" type="text" />
                  </FormField>

                  <FormField label="Email" name="safeguardingEmail">
                    <TextInput name="safeguardingEmail" type="email" />
                  </FormField>

                  <ActionButton
                    label={<Text>Add</Text>}
                    color="primary"
                    onClick={() => addSafeguardingLead()}
                    style={{ height: '35px' }}
                    alignSelf="end"
                    margin={{ bottom: 'small' }}
                  />
                </Box> */}

                <Divider color="primary" margin={{ vertical: 'small' }} />

                <Box fill direction="row" gap="small">
                  <Text margin={{ top: 'xsmall' }} size="large">
                    Behaviour Management Techniques
                  </Text>
                  <Button
                    label={
                      <FontAwesome
                        color="brand"
                        icon={['fas', 'question-circle']}
                      />
                    }
                    plain
                    tip={{
                      content: (
                        <Box
                          background={{ color: 'white' }}
                          border={{ color: 'brand', size: 'small' }}
                          direction="column"
                          pad="small"
                        >
                          <Text>
                            The techniques entered here will be included in your
                            bespoke incident report. These can be changed at any
                            time.
                          </Text>
                        </Box>
                      ),
                    }}
                  />
                </Box>

                <Box
                  direction="row-responsive"
                  gap="medium"
                  pad={{ top: 'small' }}
                >
                  <ResponsiveContext.Consumer>
                    {responsive => (
                      <Box
                        direction="column"
                        width={['xsmall', 'small'].includes(responsive) ? '100%' : '50%'}
                      >
                        <Box fill direction="row" gap="small">
                          <Text size="small">
                            What are the most common De-escalation Techniques used
                            in your service ?
                          </Text>
                          <Button
                            alignSelf="start"
                            label={
                              <FontAwesome
                                color="brand"
                                icon={['fas', 'question-circle']}
                              />
                            }
                            plain
                            tip={{
                              content: (
                                <Box
                                  background={{ color: 'white' }}
                                  border={{ color: 'brand', size: 'small' }}
                                  direction="column"
                                  pad="small"
                                >
                                  <Text>
                                    Please list the most common de-escalation used
                                    within the service setting. EG Empathy
                                  </Text>
                                  <Text>Verbal advice and support</Text>
                                  <Text>Giving space</Text>
                                  <Text>Reassurance</Text>
                                  <Text>Scripts</Text>
                                  <Text>Negotiation</Text>
                                  <Text>Positive Choices</Text>
                                  <Text>Humour</Text>
                                  <Text>Logical Consequences</Text>
                                  <Text>Tactical ignoring</Text>
                                  <Text>Take up time</Text>
                                  <Text>Time-out</Text>
                                  <Text>Supportive touch</Text>
                                  <Text>Transfer staff</Text>
                                  <Text>Success reminded</Text>
                                  <Text>Listening</Text>
                                  <Text>Acknowledgement</Text>
                                  <Text>Removing audience</Text>
                                </Box>
                              ),
                            }}
                          />
                        </Box>
                        {deescalationTechniques.length > 0 && (
                          <Grid columns={{ count: 2, size: 'auto' }}>
                            {deescalationTechniques.map(
                              (technique, index, techniques) => {
                                return (
                                  <Box
                                    direction="row"
                                    key={techniques[index].technique}
                                    margin={{ vertical: 'xsmall' }}
                                  >
                                    <CheckBox
                                      checked={
                                        deescalationTechniques[index].selected
                                      }
                                      label={
                                        <Text size="small">
                                          {techniques[index].technique}
                                        </Text>
                                      }
                                      onChange={() =>
                                        deescalationTechniqueSelect(
                                          techniques[index].technique,
                                        )
                                      }
                                    />
                                    <ActionButton
                                      label={
                                        <Text>
                                          <FontAwesome
                                            icon={['fal', 'minus-circle']}
                                            size="xs"
                                          />
                                        </Text>
                                      }
                                      margin={{ horizontal: 'xsmall' }}
                                      onClick={() =>
                                        removeTechnique('deescalation', index)
                                      }
                                      plain
                                      target="_self"
                                    />
                                  </Box>
                                );
                              },
                            )}
                          </Grid>
                        )}
                        <Box direction="row" gap="small">
                          <FormField name="deescalationTechnique">
                            <TextInput
                              name="deescalationTechnique"
                              placeholder="new technique"
                              type="text"
                            />
                          </FormField>

                          <ActionButton
                            label={
                              <Text>
                                <FontAwesome icon={['fal', 'plus-circle']} /> Add
                              </Text>
                            }
                            disabled={!deescalationAddButton}
                            color="primary"
                            onClick={() => addDeescalationTechnique()}
                            style={{ height: '35px' }}
                          />
                        </Box>
                      </Box>
                    )}
                  </ResponsiveContext.Consumer>

                  <ResponsiveContext.Consumer>
                    {responsive => (
                      <Box
                        direction="column"
                        width={['xsmall', 'small'].includes(responsive) ? '100%' : '50%'}
                      >
                        <Box fill direction="row" gap="small">
                          <Text size="small">
                            Name the Physical Interventions used in your service
                            (If applicable)
                          </Text>
                          <Button
                            alignSelf="start"
                            label={
                              <FontAwesome
                                color="brand"
                                icon={['fas', 'question-circle']}
                              />
                            }
                            plain
                            tip={{
                              content: (
                                <Box
                                  background={{ color: 'white' }}
                                  border={{ color: 'brand', size: 'small' }}
                                  direction="column"
                                  pad="small"
                                >
                                  <Text>
                                    Please list the Physical techniques used
                                    within the service setting.
                                  </Text>
                                  <Text>Figure of 4</Text>
                                  <Text>Single elbow</Text>
                                  <Text>Break way techniques</Text>
                                  <Text>Team Control</Text>
                                  <Text>Guiding hold</Text>
                                  <Text>Double Embrace</Text>
                                  <Text>
                                    The name of techniques used and trained within
                                    your service will be available from you
                                    training provider or course workbook.
                                  </Text>
                                </Box>
                              ),
                            }}
                          />
                        </Box>
                        {physicalTechniques.length > 0 && (
                          <Grid columns={{ count: 2, size: 'auto' }}>
                            {physicalTechniques.map(
                              (technique, index, techniques) => {
                                return (
                                  <Box
                                    direction="row"
                                    key={index}
                                    margin={{ vertical: 'xsmall' }}
                                  >
                                    <CheckBox
                                      checked={physicalTechniques[index].selected}
                                      label={
                                        <Text size="small">
                                          {techniques[index].technique}
                                        </Text>
                                      }
                                      onChange={() =>
                                        physicalTechniqueSelect(
                                          techniques[index].technique,
                                        )
                                      }
                                    />
                                    <ActionButton
                                      label={
                                        <Text>
                                          <FontAwesome
                                            icon={['fal', 'minus-circle']}
                                            size="xs"
                                          />
                                        </Text>
                                      }
                                      margin={{ horizontal: 'xsmall' }}
                                      onClick={() =>
                                        removeTechnique('physical', index)
                                      }
                                      plain
                                      target="_self"
                                    />
                                  </Box>
                                );
                              },
                            )}
                          </Grid>
                        )}
                        <Box direction="row" gap="small">
                          <FormField name="physicalTechnique">
                            <TextInput
                              name="physicalTechnique"
                              placeholder="new technique"
                              type="text"
                            />
                          </FormField>

                          <ActionButton
                            label={
                              <Text>
                                <FontAwesome icon={['fal', 'plus-circle']} /> Add
                              </Text>
                            }
                            disabled={!physicalAddButton}
                            onClick={() => addPhysicalTechnique()}
                            color="primary"
                            style={{ height: '35px' }}
                          />
                        </Box>
                      </Box>
                    )}
                  </ResponsiveContext.Consumer>
                </Box>

                <Divider color="primary" margin={{ top: 'large', vertical: 'medium' }} />

                <Box fill direction="row" gap="small">
                  <Text margin={{ top: 'xsmall' }} size="large">
                  Quick Behaviours
                  </Text>
                  {/* <ActionButton
                    label={
                      <FontAwesome
                        color="brand"
                        icon={['fas', 'question-circle']}
                      />
                    }
                    plain
                    tip={{
                      content: (
                        <Box
                          background={{ color: 'white' }}
                          border={{ color: 'brand', size: 'small' }}
                          direction="column"
                          pad="small"
                        >
                          <Text>
                            The techniques entered here will be included in your
                            bespoke incident report. These can be changed at any
                            time.
                          </Text>
                        </Box>
                      ),
                    }}
                  /> */}
                </Box>

                <Box
                  direction="row-responsive"
                  gap="medium"
                  pad={{ top: 'small' }}
                >
                  <ResponsiveContext.Consumer>
                    {responsive => (
                      <Box
                        direction="column"
                        width={'100%'}
                      >
                        <Box fill direction="row" gap="small">
                          <Text size="small">
                            What Quick Behaviours would you like track on the clicker?
                          </Text>
                        </Box>
                        {quickBehaviours.length > 0 && (
                          <Grid columns={{ count: 2, size: 'auto' }}>
                            {quickBehaviours.map(
                              (behaviour, index, behaviours) => {
                                return (
                                  <Box
                                    direction="row"
                                    key={behaviours[index].quickBehaviour}
                                    margin={{ vertical: 'xsmall' }}
                                  >
                                    <CheckBox
                                      checked={
                                        quickBehaviours[index].selected
                                      }
                                      label={
                                        <Text size="small">
                                          {behaviours[index].quickBehaviour}
                                        </Text>
                                      }
                                      onChange={() =>
                                        quickBehaviourSelect(
                                          behaviours[index].quickBehaviour,
                                        )
                                      }
                                    />
                                    <ActionButton
                                      label={
                                        <Text>
                                          <FontAwesome
                                            icon={['fal', 'minus-circle']}
                                            size="xs"
                                          />
                                        </Text>
                                      }
                                      margin={{ horizontal: 'xsmall' }}
                                      onClick={() =>
                                        removeQuickBehaviour(index)
                                      }
                                      plain
                                      target="_self"
                                    />
                                  </Box>
                                );
                              },
                            )}
                          </Grid>
                        )}
                        <Box direction="row" gap="small">
                          <FormField name="quickBehaviour">
                            <TextInput
                              name="quickBehaviour"
                              placeholder="New Behaviour"
                              type="text"
                            />
                          </FormField>

                          <ActionButton
                            label={
                              <Text>
                                <FontAwesome icon={['fal', 'plus-circle']} /> Add
                              </Text>
                            }
                            disabled={!quickBehaviourAddButton}
                            color="primary"
                            onClick={() => addQuickBehaviour()}
                            style={{ height: '35px' }}
                          />
                        </Box>
                      </Box>
                    )}
                  </ResponsiveContext.Consumer>
                </Box>

                <Divider color="primary" margin={{ vertical: 'large' }} />
                  <CheckBox
                    checked={enablePILExtras}
                    label={
                      <Text>
                        In line with the inspection handbook (updated January
                        2024) Would you like Behaviour Smart to recordand analysis
                        discriminatory and prejudiced behaviour. Eg bullying,
                        racist, sexist, disability and
                        homophobic/biphobic/transphobic bullying etc. Including
                        suspensions and exclusions?
                      </Text>
                    }
                    onChange={() => setEnablePILExtras(!enablePILExtras)}
                  />

                <Divider color="primary" margin={{ vertical: 'large' }} />

                  <Box fill direction="row" gap="small">
                    <Text margin={{ top: 'xsmall' }} size="large">
                      BehaviourSmart AI
                    </Text>
                    {/* <ActionButton
                      label={
                        <FontAwesome
                          color="brand"
                          icon={['fas', 'question-circle']}
                        />
                      }
                      plain
                      tip={{
                        content: (
                          <Box
                            background={{ color: 'white' }}
                            border={{ color: 'brand', size: 'small' }}
                            direction="column"
                            pad="small"
                          >
                            <Text>
                              [TODO ADD DESCRIPTION]
                            </Text>
                          </Box>
                        ),
                      }}
                    /> */}
                  </Box>

                  <CheckBox
                    checked={aiTermsAccepted}
                    label={
                      <Text>
                        Our AI suggestions are for informational purposes only. Users should evaluate and apply these ideas based on their expertise. Behaviour Smart is not liable for outcomes from these suggestions. Always consult a qualified professional for personalised guidance. Please do not share data with parents or other parties that you're not authorised to. For more information please visit <Anchor href="https://www.behavioursmart.co.uk/aipowered" target="_blank">https://www.behavioursmart.co.uk/aipowered</Anchor>
                      </Text>
                    }
                    onChange={() => setAiTermsAccepted(!aiTermsAccepted)}
                  />

                <Divider
                  color="primary"
                  margin={{ top: 'medium', bottom: 'none' }}
                />

                <Box
                  direction="row"
                  justify="between"
                  margin={{ vertical: 'medium' }}
                >
                  <ActionButton label="< Back" onClick={() => goBack()} secondary />
                  <ActionButton type="submit" label="Save" primary />
                </Box>
              </Form>
            </Box>
          </Box>
        </Box>
      </>}
    </Box>
  );
}

export default ServiceSetup
